import type { MediaCacheService } from "../types"

export const mediaCache: MediaCacheService = {
  async resolve(url) {
    return url
  },
  async invalidate() {},
  async getStats() {
    return {
      entryCount: 0,
      byteSize: 0,
      hits: 0,
      misses: 0,
      writes: 0,
      failures: 0,
    }
  },
  async clear() {},
}
